import type { SubmitReportDto } from './report.dto';
import type { ReportDraft } from './report.model';

export class ReportMapper {
  static toDto(draft: ReportDraft, technicalLogs: string): SubmitReportDto {
    return {
      category: draft.category,
      text: draft.text.trim(),
      ...(draft.messageId ? { messageId: draft.messageId } : {}),
      // Un diario vuoto non si dichiara: il campo assente e il campo a stringa vuota direbbero la
      // stessa cosa, e uno dei due la dice senza occupare il contratto.
      ...(technicalLogs ? { technicalLogs } : {}),
    };
  }
}
